// extracted by mini-css-extract-plugin
export var introData = "style-module--introData--ee6ce";
export var productHero = "style-module--productHero--5fd25";
export var sectionTitleSlate = "style-module--sectionTitleSlate--6f977";
export var slate2Overview = "style-module--slate2Overview--a655e";
export var videoContainer = "style-module--video-container--e9094";